export const addUserInfo = (currentUser) => [
  { p: ['users', currentUser.userId], oi: currentUser },
];
